import React, { useEffect, useState } from "react";
import AuthLayout from "../../layout/AuthLayout";
import {
  Backdrop,
  Box,
  CircularProgress,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { CustomPasswordInput } from "../../components/Common/CustomInputs";
import { LoginOutlined } from "@mui/icons-material";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CustomBtn } from "../../components/Common/CustomBtn";
import axios from "axios";
import { BASE_URL } from "../../utils/config/config";
import {
  ConfirmationSnackbar,
  ErrorSnackbar,
} from "../../components/Common/CustomSnackbar";

const ResetPassword = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const mediumScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [success, setSuccess] = useState(false);
  const [errorState, setErrorState] = useState({ error: false, message: "" });
  const token = searchParams.get("token");
  useEffect(() => {
    if (!token) {
      setErrorState({ error: true, message: "Invalid token" });
      navigate("/login");
    }
  }, [token, navigate]);
  const handleSubmit = async () => {
    if (!password || !confirmPassword) {
      setErrorState({ error: true, message: "Please fill all fields" });
      return;
    }
    if (password !== confirmPassword) {
      setErrorState({ error: true, message: "Passwords do not match" });
      return;
    }
    try {
      setLoading(true);
      const response = await axios.post(`${BASE_URL}user/reset-password`, {
        token,
        newPassword: password.trim(),
      });

      if (response.status === 200) {
        setSuccess(true);
        setTimeout(() => navigate("/login"), 2000);
      }
    } catch (error) {
      console.error("Error resetting password:", error);
      setErrorState({
        error: true,
        message: error?.response?.data?.message || "Something went wrong",
      });
    } finally {
      setLoading(false);
    }
  };
  return (
    <AuthLayout>
      <ConfirmationSnackbar
        snackbarState={success}
        handleSnackbarClose={() => setSuccess(false)}
        text={"Password reset successfully! Redirecting to login..."}
      />
      <ErrorSnackbar
        error={errorState.error}
        handleCloseError={() => setErrorState({ error: false, message: "" })}
        errorMsg={errorState.message}
      />
      <Box sx={{ px: 4 }}>
        <Typography
          sx={{
            fontFamily: "'Gotham', sans-serif",
            fontSize: "50px",
            color: theme.palette.text.primary,
          }}
        >
          Reset Password
        </Typography>
        <Typography
          sx={{
            fontFamily: "'Quicksand', sans-serif",
            fontSize: "22px",
            color: theme.palette.text.primary,
          }}
        >
          Enter your new password below.
        </Typography>

        <Box sx={{ my: 5, width: "100%" }}>
          <CustomPasswordInput
            placeholder="New Password"
            value={password}
            setValue={setPassword}
            width={"100%"}
          />

          <Box sx={{ mt: 3 }}>
            <CustomPasswordInput
              placeholder="Confirm Password"
              value={confirmPassword}
              setValue={setConfirmPassword}
              width={"100%"}
            />
          </Box>
        </Box>

        <CustomBtn
          text="Reset Password"
          Icon={LoginOutlined}
          width={mediumScreen ? "60%" : "40%"}
          onClick={handleSubmit}
        />
      </Box>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </AuthLayout>
  );
};

export default ResetPassword;
